import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

const nodePositions = [
  { cx: 165, cy: 31 },
  { cx: 147, cy: 57 },
  { cx: 141, cy: 73 },
  { cx: 191, cy: 32 },
  { cx: 186, cy: 59 },
  { cx: 213, cy: 66 },
  { cx: 175, cy: 137 },
  { cx: 195, cy: 128 },
  { cx: 198, cy: 48 },
  { cx: 210, cy: 100 },
  { cx: 156, cy: 129 }
];

export default function AnimatedLogo() {
  const [activeNodes, setActiveNodes] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const active = new Set();
      while (active.size < 4) {
        active.add(Math.floor(Math.random() * nodePositions.length));
      }
      setActiveNodes([...active]);
    }, 400);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full h-full flex justify-center items-center bg-black p-4 rounded-2xl shadow-lg">
      <svg viewBox="0 0 300 180" width="200" height="200">
        <image
          href="/aicity_logo.svg"
          x="0"
          y="0"
          width="300"
          height="180"
          preserveAspectRatio="xMidYMid meet"
        />

        {nodePositions.map((node, index) => (
          <motion.circle
            key={index}
            cx={node.cx}
            cy={node.cy}
            r={activeNodes.includes(index) ? 5 : 3}
            fill={activeNodes.includes(index) ? '#00a2ff' : '#007bbd'}
            animate={{ scale: activeNodes.includes(index) ? 1.4 : 1 }}
            transition={{ duration: 0.4 }}
          />
        ))}
      </svg>
    </div>
  );
}